import type { FC, ReactElement } from 'react';

import { useLegacyContext } from '../../components/legacyMode/LegacyContextProvider';
import { Logger } from '../../logger/Logger';
import { L10nText } from '../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../store/CoreStore';
import { useSettingsSlice } from '../../store/slices/settings/selectors';
import { settingsActions } from '../../store/slices/settings/slice';
import { StreamQuality } from '../../store/slices/settings/types';
import { useIsLegacyDesktop } from '../../styles/hooks/legacyMedia';
import { ControlContainer } from '../controls/controlContainer/ControlContainer';
import { RadioGroup } from '../controls/radioGroup/RadioGroup';

export const SettingsVideoConnected: FC = (): ReactElement => {
  const isStreamEnabled = useSettingsSlice.getIsStreamEnabled();
  const streamQuality = useSettingsSlice.getStreamQuality();
  const { isLegacyMode } = useLegacyContext();
  const isLegacyDesktop = useIsLegacyDesktop();
  const showOffset = !isLegacyMode || !isLegacyDesktop;

  const dispatch = useCoreDispatch();

  return (
    <ControlContainer label={<L10nText tk="VIDEO_QUALITY" />} column offset={showOffset}>
      <RadioGroup
        disabled={!isStreamEnabled}
        name="settings-video-quality"
        options={[
          {
            label: <L10nText tk="AUTO" />,
            value: StreamQuality.Auto.toString(),
          },
          {
            label: <L10nText tk="LOW" />,
            value: StreamQuality.Low.toString(),
          },
          {
            label: <L10nText tk="MEDIUM" />,
            value: StreamQuality.Medium.toString(),
          },
          {
            label: <L10nText tk="HIGH" />,
            value: StreamQuality.High.toString(),
          },
          // still waiting for this to be approved: (https://pragmaticplay.atlassian.net/browse/LCE-71231)
          /*{
            disabled: isOptionDisabled(StreamQuality.Low),
            label: <L10nText tk="LOW" />,
            tooltip: {
              disabled: !isOptionDisabled(StreamQuality.Low) || !isStreamEnabled,
              text: 'AUTO_IS_RECOMMENDED',
            },
            value: StreamQuality.Low.toString(),
          },
          {
            disabled: isOptionDisabled(StreamQuality.Medium),
            label: <L10nText tk="MEDIUM" />,
            tooltip: {
              disabled: !isOptionDisabled(StreamQuality.Medium) || !isStreamEnabled,
              text: 'AUTO_IS_RECOMMENDED',
            },
            value: StreamQuality.Medium.toString(),
          },
          {
            disabled: isOptionDisabled(StreamQuality.High),
            label: <L10nText tk="HIGH" />,
            tooltip: {
              disabled: !isOptionDisabled(StreamQuality.High) || !isStreamEnabled,
              text: 'AUTO_IS_RECOMMENDED',
            },
            value: StreamQuality.High.toString(),
          },*/
        ]}
        onChange={(value) => {
          Logger.logEvent('settingsChangeVideo', {
            additional: value,
          });
          dispatch(settingsActions.setStreamQuality(value as StreamQuality));
        }}
        value={streamQuality.toString()}
      />
    </ControlContainer>
  );
};
